import { useCallback } from "react";
import useAuthenticatedRequest from "./TokenRefreshUtils";

const useReceiptPrinter = () => {

    const authenticatedRequest = useAuthenticatedRequest();

    const printReceipt = useCallback(async (actId, toast) => {

        let entityId = null;

        const settingsUrl = `${process.env.REACT_APP_BACKEND_URL}kasa_shifts/get_cash_app_settings/`;
        const settingsOptions = {
            method: "GET",
            headers: { 'Content-Type': 'application/json' }
        };
        const response = await authenticatedRequest(settingsUrl, settingsOptions);

        if (response.status === 200) {
            const parsedResponse = await response.json();

            if (parsedResponse.check_template_id) {
                entityId = parsedResponse.check_template_id;
            }
        }

        if (entityId) {
            const url = `${process.env.REACT_APP_BACKEND_URL}templates/generate_template/`;
            const options = {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify([{
                    template_id: entityId,
                    entity_id: actId,
                    quantity: 1
                }])
            };
            const response = await authenticatedRequest(url, options);

            if (response.status === 200) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;

                link.download = `receipt${actId}.pdf`;
                document.body.appendChild(link);
                link.click();

                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);

                toast.current.show({ severity: 'success', summary: 'Створення документу', detail: 'Документ створено', life: 3000 });
            }
            else {
                toast.current.show({ severity: "error", summary: "Створення документу", detail: "Документ не створено", life: 3000 });
            }
        }
        else {
            toast.current.show({ severity: "error", summary: "Отримання темплейту", detail: "Темплейт чеку не було знайдено", life: 3000 });
        }
    }, [authenticatedRequest]);

    return printReceipt;
}

export default useReceiptPrinter;